export default __webpack_public_path__ + "static/media/bg_loyalty.840b7fc8.svg";